import classnames from 'classnames';
import { PropsWithChildren } from 'lib-shared-types-utils';

import styles from './metricInstrumentsGrid.module.scss';

type MetricInstrumentsGridProps = {
  /** Whether the grid is bounded with a max-width. */
  bounded?: boolean;
  /** Whether the grid renders as many columns as it possibly can. */
  fluid?: boolean;
} & PropsWithChildren;

export const MetricInstrumentsGrid = ({
  bounded = false,
  fluid = false,
  children,
}: MetricInstrumentsGridProps): JSX.Element => {
  const rootClass = classnames(styles.root, {
    [styles.rootBounded]: bounded,
    [styles.rootFluid]: fluid,
  });

  return <div className={rootClass}>{children}</div>;
};
